import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_DELETE_ATTACHMENTS = `${MODULE_PREFIX}_DELETE_ATTACHMENTS`;
export const QUESTIONNAIRE_EVALUATION_DELETE_ATTACHMENTS_SUCCESS = `${MODULE_PREFIX}_DELETE_ATTACHMENTS_SUCCESS`;
export const questionnaireEvaluationDeleteAttachment = (requestData) => ({
    type: QUESTIONNAIRE_EVALUATION_DELETE_ATTACHMENTS,
    payload: requestData
});
export const questionnaireEvaluationDeleteAttachmentSuccess = (payload) => ({
    type: QUESTIONNAIRE_EVALUATION_DELETE_ATTACHMENTS_SUCCESS,
    payload
});
//# sourceMappingURL=questionnaireEvaluationDeleteAttachmentActions.js.map